var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12h-2V5H4v13.385L5.763 17H12v2H6.455L2 22.5V4a1 1 0 011-1h18a1 1 0 011 1v8zm-7.855 7.071a4.004 4.004 0 010-2.142l-.975-.563 1-1.732.976.563A3.996 3.996 0 0117 14.126V13h2v1.126a3.99 3.99 0 011.854 1.071l.976-.563 1 1.732-.975.563a4.004 4.004 0 010 2.142l.975.563-1 1.732-.976-.563c-.501.51-1.14.887-1.854 1.071V23h-2v-1.126a3.996 3.996 0 01-1.854-1.071l-.976.563-1-1.732.975-.563zM18 20a2 2 0 100-4 2 2 0 000 4z"
  })));
}

export default SvgChat;